import { TextureLayerProps } from '../types/layer';

export default class TextureLayer {
  protected readonly context: CanvasRenderingContext2D;
  protected readonly canvas: HTMLCanvasElement;

  protected width: number;
  protected height: number;

  public needsRender = true;
  public visible = true;
  public index = 0;

  constructor({ w, h, visible }: TextureLayerProps) {
    this.canvas = document.createElement('canvas');
    this.context = this.canvas.getContext('2d');
    this.width = this.canvas.width = w;
    this.height = this.canvas.height = h;
    this.visible = visible ?? true;
    this.context.imageSmoothingEnabled = true;
    this.context.imageSmoothingQuality = 'high';
  }

  test() {
    this.getCanvas().toBlob((e) => {
      window.open(URL.createObjectURL(e));
    });
  }

  hit(mouse) {
    return false;
  }

  render(size) {
    if (!this.needsRender) return false;

    this.context.clearRect(0, 0, this.width, this.height);

    this.needsRender = false;
    return true;
  }

  getCanvas() {
    return this.canvas;
  }

  toJSON() {
    return {};
  }

  getContext() {
    return this.context;
  }
}
